<template>
  <v-app>
<!--    app bar-->
    <v-app-bar app>
      <div v-if="user">
        <v-app-bar-nav-icon v-if="user.emailVerified"  @click.stop="drawer = !drawer">
          <v-icon>view_headline</v-icon>
        </v-app-bar-nav-icon>
      </div>


      <v-toolbar-title >
        <router-link v-if="user"  :to="'/'">
          <v-img
              v-if="user.headerMediaUrl"
              :src="user.headerMediaUrl"
              class="shrink mt-1 mb-5 mt-2"
              contain
              min-width="180"
              width="150"
          />
          <v-img
              v-else
              src="./assets/Flexline Toolbar Logo(400 x 100 px).png"
              class="shrink mt-1 mb-5 mt-2"
              contain
              alt="Flexline"
              min-width="180"
              width="150"
          />
        </router-link>
        <div @click="routeToLandingPage" v-else>
          <v-img
              src="./assets/Flexline Toolbar Logo(400 x 100 px).png"
              class="shrink mt-1 mb-5 mt-2"
              contain
              alt="Flexline"
              min-width="180"
              width="150"
          />
        </div>
      </v-toolbar-title>


      <v-spacer></v-spacer>
      <v-btn v-if="!user" text outlined color="blue-grey darken-4" @click="route({route: '/signin', type: 'link'})">Signin</v-btn>
<!--lis tof items from right navbar button-->
      <div v-if="user" class="text-center justify-center">
        <v-menu  offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on">
              <v-icon dark>mdi-account-details</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="user.exists" @click="routeToSettings">
              <v-list-item-title>Account Settings</v-list-item-title>
            </v-list-item>
            <v-list-item @click="signUserOut">
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

    </v-app-bar>
<!--    nav drawer-->
    <v-navigation-drawer
        app
        v-if="user"
        v-model="drawer"
    >
      <div  v-if="user.exists">
        <v-list dense v-for="item in drawerItems"  :key="item.icon">
          <!--link to admin panel-->
          <v-list-item @click="route(item)" link>
            <v-list-item-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{item.title}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn text @click="signUserOut" block>
            <v-icon>mdi-exit-to-app</v-icon>
            Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
<!--    main router view-->
      <v-main fluid>
          <router-view/>
      </v-main>
    <div style="height: 50px"></div>
<!--footer component-->
    <v-footer absolute padless>
<!--      <v-container fluid>-->
          <v-card
              class="flex"
          >
<!--            <v-card-title class="cyan">-->
<!--              <strong class="subheading white&#45;&#45;text" >Get connected with us on socials!</strong>-->

<!--              <v-spacer></v-spacer>-->

<!--              <v-btn-->
<!--                  v-for="icon in icons"-->
<!--                  :key="icon"-->
<!--                  class="mx-4"-->
<!--                  dark-->
<!--                  icon-->
<!--              >-->
<!--                <v-icon size="24px">-->
<!--                  {{ icon }}-->
<!--                </v-icon>-->
<!--              </v-btn>-->

<!--            </v-card-title>-->

            <v-card-text class="py-2  text-center white--text grey darken-4">
               Powered by <strong>Flexline</strong> — ⓒ{{ new Date().getFullYear() }}
            </v-card-text>
          </v-card>
<!--      </v-container>-->
    </v-footer>

  </v-app>
</template>
<script>

export default {
  data: () => ({
    icons: [
      'mdi-facebook',
      'mdi-twitter',
      'mdi-linkedin',
      'mdi-instagram',
    ],
    drawer: false,
    drawerItems: [
      // {title: 'Dashboard', route: '/', icon: 'mdi-view-dashboard-outline', type: 'link'},
      // {title: 'Phone Numbers', route: '/managePhoneNumbers', icon: 'mdi-phone-plus', type: 'link'},
      // {title: 'Bookings', route: '/bookings', icon: 'list_alt', type: 'link'},
      // {title: 'Catalogue', route: '/listings', icon: 'storefront', type: 'link'},
      // {title: 'Segments', route: '/segmentViewer', icon: 'segment', type: 'link'},
      // {title: 'Payments', route: '/transactions', icon: 'attach_money', type: 'link'},
      // {title: 'Billing and Usage', route: '/billingAndUsage', icon: 'data_usage', type: 'link'},
      // {title: 'Profile Settings', route: '/editProfile', icon: 'mdi-account', type: 'link'},
      // {title: 'Log out', route: '', icon: 'mdi-exit-to-app', type: 'method', method: 'signUserOut'}
    ]
  }),
  computed: {
    subscriptions () {
      return this.$store.getters.subscriptions
    },
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
  },
  watch: {
    subscriptions (value) {
      // console.log(value)
      if (value) {
        this.setNavLinks()
      }
    },
    user (value) {
      // console.log(value)
      if (value == null) {
        this.drawer = false
      }
      if (value.isAnonymous) {
        this.drawerItems = null
        // console.log(value)
      }
    }
  },
  created () {
    if (!this.subscriptions) {
      this.drawerItems = [
        {title: 'Dashboard', route: '/', icon: 'mdi-view-dashboard-outline', type: 'link'},
        {title: 'Billing and Usage', route: '/billingAndUsage', icon: 'data_usage', type: 'link'},
        {title: 'Profile Settings', route: '/editProfile', icon: 'mdi-account', type: 'link'}
      ]
    }
  },
  methods: {
    setNavLinks () {
      // console.log(this.subscriptions)
      let drawerItems = []
      drawerItems.push({title: 'Dashboard', route: '/', icon: 'mdi-view-dashboard-outline', type: 'link'})
      let subs = this.subscriptions
      let subLinks = []
      subs.forEach((sub) => {
        if (sub.id === 'bookings') {
          subLinks.push({title: 'Bookings', route: '/bookings', icon: 'list_alt', type: 'link'})
        }
        if (sub.id === 'flexConnect') {
          subLinks.push({title: 'FlexConnect', route: '/segmentViewer', icon: 'segment', type: 'link'})
        }
        if (sub.id === 'flexlinePhoneNumber') {
          subLinks.push({title: 'Phone Numbers', route: '/managePhoneNumbers', icon: 'mdi-phone-plus', type: 'link'},)
        }
        if (sub.id === 'onlineListing') {
          subLinks.push({title: 'Catalogue', route: '/listings', icon: 'storefront', type: 'link'})
        }
        if (sub.id === 'payments') {
          subLinks.push({title: 'Payments', route: '/transactions', icon: 'attach_money', type: 'link'})
        }
      })
      let systemLinks = [
        {title: 'Billing and Usage', route: '/billingAndUsage', icon: 'data_usage', type: 'link'},
        {title: 'Profile Settings', route: '/editProfile', icon: 'mdi-account', type: 'link'}
      ]
      this.drawerItems = drawerItems.concat(subLinks, systemLinks)
      // console.log(this.drawerItems)
    },
    routeToLandingPage () {
      window.open('https://flexline.app/')
    },
    routeToSettings () {
      this.$router.push('/editProfile')
    },
    signUserOut () {
     this.$store.dispatch('logout')
    },
    route (drawerItem) {
      if (drawerItem.type !== 'method') {
        this.$router.push(drawerItem.route)
      } else {
        if (drawerItem.method === 'signUserOut') {
          this.signUserOut()
        }
      }
    }
  }
}
</script>
